module.exports = __webpack_public_path__ + "img/Group-1945.ae004c83.png";